export const POST_ROLE_REQUEST = "POST_ROLE_REQUEST";
export const POST_ROLE_SUCCESS = "POST_ROLE_SUCCESS";
export const POST_ROLE_FAILURE = "POST_ROLE_FAILURE";
